module.exports = __webpack_public_path__ + "static/media/turnover-times.b4fc75e9.png";